<script setup>
import { appConfig } from '@/lib/appConfig';
import { notification } from '@/lib/errorHandler';
import { computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import PersonalHeader from "../../components/personal_area/PersonalHeader.vue";
import PersonalProfile from "../../components/personal_area/PersonalProfile.vue";
import PersoneInCaption from "../../components/personal_area/PersoneInCaption.vue";


const route = useRoute();
const router = useRouter();
const { getters } = useStore()
const note = ref(null);
const disableDeleteButton = ref(false);

function parseCustomDateTime(datePart, timePart) {
  const [day, month, year] = datePart.split('.').map(Number);
  const [hours, minutes] = timePart.split(':').map(Number);
  return new Date(year, month - 1, day, hours, minutes);
}

const dateInfo = computed(() => {
  const d = parseCustomDateTime(note.value.date, note.value.time);
  const date = new Intl.DateTimeFormat('ru-RU', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(d);

  const time = new Intl.DateTimeFormat('ru-RU', {
    hour: 'numeric',
    minute: 'numeric',
  }).format(d);

  return { date, time };
});

async function getNote() {
  try {
    const url = new URL(`/note/${route.params.id}`, appConfig.domain);
    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        'X-Auth-Token': getters.token,
      }
    });
    const data = await response.json();
    note.value = data;
  } catch {
    await router.push({ name: 'diaryPage' });
  }
}


async function deleteNote() {
  if (!note.value?.id) return;
  try {
    const url = new URL(`/note/${route.params.id}`, appConfig.domain);
    await fetch(url, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-Auth-Token': getters.token,
      }
    });
    notification.successNotification(this, 'Успешно удалено');
    await router.push({ name: 'diaryPage' });
  } catch (error) {
    console.log(error)
  }
}


getNote();
</script>

<template>
  <div class="body">
    <PersonalHeader />
    <main v-if="note" class="main">
      <div class="caption flex al-cent">
        <div class="caption-greetings">
          <h1 class="caption-greetings__title">
            МОИ ЗАМЕТКИ</h1>
        </div>
        <PersoneInCaption />
      </div>
      <div class="head">
        <RouterLink :to="{ name: 'diaryPage' }" class="head__link">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5.3326 13.3335L4.38993 14.2761L3.44727 13.3335L4.38993 12.3908L5.3326 13.3335ZM27.9993 24.0001C27.9993 24.3537 27.8588 24.6929 27.6087 24.9429C27.3587 25.193 27.0196 25.3335 26.6659 25.3335C26.3123 25.3335 25.9732 25.193 25.7231 24.9429C25.4731 24.6929 25.3326 24.3537 25.3326 24.0001H27.9993ZM11.0566 20.9428L4.38993 14.2761L6.27527 12.3908L12.9419 19.0575L11.0566 20.9428ZM4.38993 12.3908L11.0566 5.72412L12.9419 7.60945L6.27527 14.2761L4.38993 12.3908ZM5.3326 12.0001H18.6659V14.6668H5.3326V12.0001ZM27.9993 21.3335V24.0001H25.3326V21.3335H27.9993ZM18.6659 12.0001C21.1413 12.0001 23.5153 12.9835 25.2656 14.7338C27.0159 16.4841 27.9993 18.8581 27.9993 21.3335H25.3326C25.3326 19.5653 24.6302 17.8697 23.38 16.6194C22.1297 15.3692 20.434 14.6668 18.6659 14.6668V12.0001Z"
              fill="black" />
          </svg>
          Вернуться к заметкам
        </RouterLink>
      </div>
      <div class="filling ">
        <div class="note">
          <div class="note-top">
            <div class="note-element">
              <p class="note__text">Название</p>
              <p class="title">{{ note.title }}</p>
            </div>

            <button class="delete" :disabled="disableDeleteButton" @click="deleteNote">
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_0_192)">
                  <path
                    d="M12 38C12 40.21 13.79 42 16 42H32C34.21 42 36 40.21 36 38V14H12V38ZM38 8H31L29 6H19L17 8H10V12H38V8Z"
                    fill="#FF2031" />
                </g>
                <defs>
                  <clipPath id="clip0_0_192">
                    <rect width="48" height="48" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </button>
          </div>

          <div class="note-element note-element--2">
            <p class="note__text">Описание</p>
            <p class="text">{{ note.description }}</p>
          </div>
          <div class="note-flex note-element--3">
            <div class="note-element">
              <p class="note__text">Дата и время</p>
              <p class="text">{{ dateInfo.date }}</p>
            </div>
            <div class="note-element">
              <p class="note__text">Время</p>
              <p class="text">{{ dateInfo.time }}</p>
            </div>
          </div>
        </div>

      </div>
      <router-link :to="{ name: 'diaryPage' }" class="back">
        Назад к заметкам
      </router-link>
    </main>
    <PersonalProfile />
  </div>
</template>
<style scoped>
.body {
  display: flex;
}

.main {
  margin: 0 60px 56px 40px;
  width: 100%;
}

.content-element-caption__title {
  font-family: "Montserrat";
  font-weight: 500;
  font-size: 20px;
  line-height: 1;
}

.content-element-caption__more {
  font-size: 14px;
  line-height: 1;
  position: relative;
  padding-right: 20px;
  color: rgba(16, 12, 64, 0.699999988079071);
}

.content-element-caption__more::after {
  position: absolute;
  background: url(../../assets/img/list.svg);
  content: "";
  display: block;
  right: 0;
  top: -2px;
  width: 16px;
  height: 16px;
}

/* Caption */

.caption {
  padding: 40px 0px 0px 0px;
}

.caption-greetings__title {
  font-family: "PT";
  font-weight: 700;
  font-size: 48px;
  line-height: 1.2;
}

/* filling */
.filling {
  max-width: 100%;
  width: 100%;
  align-items: flex-start;
}

.content-element {
  max-width: 100%;
  width: 100%;
}



/*content*/
.content {
  padding: 20px 0px 0px 0px;
  width: 100%;
}

.check {
  display: flex;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.check:hover {
  opacity: 0.8;
}

.check__input {
  position: absolute;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.check__input:checked~.check__box {
  display: none;
}

.check__input:checked~.check__box-on {
  display: flex;
}

.check__box {
  width: 100%;
  height: 100%;
}

.check__box-on {
  display: none;
}

.filter-element {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.check-text {
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  color: #100c40;
}

.head {
  margin-top: 25px;

}

.head__link {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  font-size: 16px;
  line-height: 140%;
  color: rgba(0, 0, 0, 0.6);
}

.add-note {
  display: flex;
  gap: 24px;
  padding: 24px;
  max-width: 536px;
  width: 100%;
  font-weight: 400;
  font-size: 36px;
  line-height: 120%;
  color: #fff;
  border-radius: 10px;
  background: #ff2031;
  align-items: center;
}

.filter {
  margin-top: 32px;
  position: relative;
}

.filter-content {
  display: flex;
  align-items: center;
  gap: 16px;
  font-weight: 500;
  font-size: 20px;
  line-height: 100%;
  color: #100c40;

}

.filter-list {
  margin-top: 5px;
  padding: 16px 24px;
  border-radius: 12px;
  box-shadow: 0 40px 30px 0 rgba(0, 0, 0, 0.06);
  background: #fff;
  display: flex;
  flex-direction: column;
  gap: 13px;
  width: unset;
  position: absolute;
  left: -16px;
  opacity: 0;
  pointer-events: none;
  transform: translateY(-10px);
  transition: transform 0.5s ease-in-out;
}

.filter-list--open {
  opacity: 1;
  pointer-events: all;
  transform: translateY(0);
  z-index: 10;
}

.filling {
  margin-top: 32px;
}

.diary-group {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
}

.note {
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid #F7AD3D;
  padding: 32px;
  max-width: 820px;
  width: 100%;
  border-radius: 10px;
}

.note-element--2 {
  margin-top: 15px;
}

.note-element--3 {
  margin-top: 24px;
}

.note-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.delete {
  display: flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
}

.delete svg {
  width: 100%;
  height: 100%;
}

.delete:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.note__text {
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;
  color: rgba(0, 0, 0, 0.3);
}

.title {
  margin-top: 8px;
  font-weight: 500;
  font-size: 32px;
  line-height: 100%;
  color: #100c40;
}

.back {
  margin-top: 24px;
  background: #a7a5b9;
  border-radius: 8px;
  max-width: 386px;
  width: 100%;
  height: 44px;
  font-weight: 500;
  font-size: 12px;
  line-height: 100%;
  text-align: center;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}


@media (max-width: 1300px) {
  .main {
    margin-left: 20px;
  }

  /* Caption */
  .caption {
    padding: 40px 0px 30px 0px;
    justify-content: space-between;
  }

  .caption-greetings__title {
    font-size: 24px;
  }

}

@media (max-width: 950px) {
  .body {
    flex-direction: column;
  }

  .filling {
    flex-direction: column;
  }

  .caption {
    padding: 40px 0 0 0;
  }

  .caption-greetings {
    margin: 0 auto;
  }

  .caption-greetings__title {
    font-size: 32px;
  }

  .main {
    margin-left: 0;
    margin-right: 0;
    padding: 0 20px;
  }

  .profile {
    display: none;
  }

  .note {
    padding: 16px;
  }

  .title {
    font-size: 24px;
  }

  /* additionall */
  .my-course-group {
    overflow-x: scroll;
  }

  .additionally-element {
    text-align: center;
  }

  .additionally {
    max-width: 100%;
  }

  .my-course-group {
    margin-top: 20px;
    flex-direction: row;
    overflow-x: visible;
    padding: 10px;
    position: relative;
  }

  .slider-last-block {
    display: block;
    position: absolute;
    width: 24px;
    height: 24px;
    left: -10px;
    bottom: 40%;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.09);
    border-radius: 100%;
    z-index: 2;
  }

  .my-course-group-wrapper {
    flex-direction: row;
    overflow-x: scroll;
  }

  .slider-next-block {
    display: block;
    position: absolute;
    width: 24px;
    height: 24px;
    right: -10px;
    bottom: 40%;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.09);
    border-radius: 100%;
    z-index: 2;
  }

  .slider-next-block img {
    width: 24px;
    height: 24px;
  }

  .slider-last-block img {
    width: 24px;
    height: 24px;
  }

  .separate-curse {
    max-width: 280px;
  }

  .filling-element {
    margin-bottom: 40px;
    margin-right: 0;
  }

  .content-filling {
    grid-template-columns: repeat(2, 1fr);
  }

  .slider-filling-element {
    margin: 0 auto 20px auto;
  }
}

@media (max-width: 600px) {
  .main {
    padding: 0 10px;
  }

  .carousel {
    display: flex;
    text-align: center;
    flex-direction: column;
    padding: 20px 20px 45px 20px;
  }

  .carousel * {
    margin: 0 auto;
  }

  .carousel-title {
    max-width: 267px;
    font-size: 32px;
  }

  .carousel-text {
    margin-top: 10px;
    max-width: 267px;
    font-size: 12px;
  }

  .carousel-button {
    margin-top: 199px;
    max-width: 223px;
  }

  .carousel-img {
    width: 298px;
    height: 282px;
    right: calc(50% - 149px);
  }

  .content {
    padding: 0 0 00px 0;
  }

  /*category*/
  .category-element {
    padding: 0;
    margin-top: 20px;
  }

  .category-element__caption {
    margin-bottom: 0;
  }

  /* description */
  .description {
    margin-top: 20px;
  }

  .description-nav {
    position: relative;
  }

  .description-nav-selected {
    display: flex;
    align-items: center;
    padding: 16px 20px;
    background: #ffffff;
    border: 1px solid rgba(16, 12, 64, 0.2);
    border-radius: 10px;
    justify-content: space-between;
    width: 100%;
    box-shadow: 0px 40px 140px rgba(0, 0, 0, 0.06);
  }

  .description-nav-selected__text {
    font-family: "Gilroy";
    font-weight: 500;
    font-size: 14px;
    line-height: 1.6;
    color: rgba(16, 12, 64, 0.699999988079071);
  }

  .description-nav-filling {
    display: none;
    background: #fff;
    max-width: 100%;
    width: 100%;
    flex-direction: column;
    position: absolute;
    z-index: 2;
  }

  .description-nav__element {
    width: 100%;
    text-align: left;
    font-family: "Gilroy";
    font-weight: 500;
    font-size: 14px;
    line-height: 1.6;
    color: rgba(16, 12, 64, 0.699999988079071);
  }

  .description-nav__element-chozen {
    background: #fff;
    color: rgba(16, 12, 64, 0.699999988079071);
  }

  .description-nav__element:not(:last-child) {
    border-bottom: 1px solid rgba(16, 12, 64, 0.4);
    border-radius: 0 0 0 0;
  }

  .description-nav__element:first-child {
    border-radius: 10px 10px 0 0;
  }

  /*popular-course*/
  .content-element-caption__title {
    font-size: 20px;
    margin: 0 auto;
  }

  .content-element-caption__more {
    display: none;
  }

  .popular-course-filling {
    padding: 20px 0;
  }

  .tags {
    flex-wrap: nowrap;
    overflow-x: scroll;
    margin-top: 50px;
  }

  .content-filling {
    display: flex;
    flex-direction: column;
    max-width: 100%;
    padding: 20px 0 0 0;
  }
}

.text {
  margin-top: 8px;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  color: rgba(16, 12, 64, 0.7);
}

.note-flex {
  display: flex;
  gap: 46px;
}

.time {
  font-size: 14px;
  line-height: inherit;
  color: rgba(16, 12, 64, 0.699999988079071);
  margin: 0;
}
</style>